import React from 'react';

import type { SavedScheduleResult } from '../../../../../apis/campaignGraphqlManager/customPacing/types';
import FileDropzone from '../../common/components/FileDropzone/FileDropzone';
import CustomPacingScheduleHeader from '../CustomPacingScheduleHeader';
import { useCustomPacingScheduleContext } from '../CustomPacingScheduleProvider/CustomPacingScheduleProvider';
import DefaultContentWrapper from '../DefaultContentWrapper/DefaultContentWrapper';
import { Step } from '../types';
import useCSVUpload from './useCsvUpload/useCSVUpload';

const CSVUploadStep = (): React.JSX.Element => {
  const onAfterSuccessSaveSchedule = (saveScheduleResult: SavedScheduleResult): void => {
    goToStep(Step.Result);
    setSavedScheduleResult(saveScheduleResult);
  };

  const {
    hovering,
    getRootProps,
    getInputProps,
    percentUploaded,
    loading,
    cancelRequest,
    csvAddedFileName,
    onUploadCSV,
  } = useCSVUpload({ onSuccessCSVUpload: onAfterSuccessSaveSchedule });

  const { goToStep, setSavedScheduleResult } = useCustomPacingScheduleContext();

  return (
    <div data-testid="csv-upload">
      <CustomPacingScheduleHeader confirmButtonDisabled={!csvAddedFileName || loading} onConfirm={onUploadCSV} />
      <DefaultContentWrapper>
        <FileDropzone
          title="Upload Custom Pacing Schedule"
          uploadMessage="Uploading CSV file"
          dropText="Drop CSV files here or import from:"
          fileLabel="CSV to upload:"
          infoText="Please upload the CSV before saving the schedule."
          formatLabel=".CSV"
          hovering={hovering}
          loading={loading}
          percentUploaded={percentUploaded}
          cancelRequest={cancelRequest}
          fileAddedName={csvAddedFileName}
          getRootProps={getRootProps}
          getInputProps={getInputProps}
        />
      </DefaultContentWrapper>
    </div>
  );
};

export default CSVUploadStep;
